import { session, setAuthHeader } from '@/api/session'

export default {
  getAllNotifications(limit, offset) {
    let url = `${process.env.VUE_APP_BACKEND_API_URL}commons/notification/?limit=${limit}&offset=${offset}`
    return session.get(url, setAuthHeader())
  },
  setIsViewedNotifications(pk) {
    let url = `${process.env.VUE_APP_BACKEND_API_URL}commons/notification/${pk}/set_is_viewed/`
    return session.post(url, {}, setAuthHeader())
  },
  setIsViewedAllNotifications() {
    let url = `${process.env.VUE_APP_BACKEND_API_URL}commons/notification/set_is_viewed_to_all/`
    return session.post(url, {}, setAuthHeader())
  },
  setIsDeleteNotification(pk) {
    let url = `${process.env.VUE_APP_BACKEND_API_URL}commons/notification/${pk}/set_is_delete/`
    return session.post(url, {}, setAuthHeader())
  }
}
